module.exports = __webpack_public_path__ + "static/media/117.427018ea.png";